module.exports = __webpack_public_path__ + "media/images/OnDeviceheader-d1e9b359.png";